import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const DonorDataPolicy = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="donor-data-policy-page">
      <section className="bg-terracotta py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl text-white">Donor Data Policy</h1>
          <p className="font-body text-white/80 mt-2">Last updated: January 2026</p>
        </div>
      </section>
      
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Card className="bg-white rounded-2xl border-none shadow-sm">
            <CardContent className="p-8 md:p-12 space-y-8 font-body text-gray-700 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Our Commitment</h2>
                <p>Dharma Astra Association is committed to maintaining the trust and confidence of our donors. This policy outlines how we collect, use, and protect donor information.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Information We Collect</h2>
                <p className="mb-4">When you make a donation, we collect:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Full Name</li>
                  <li>Contact Information (email, phone, address)</li>
                  <li>PAN Card Number (required for 80G tax exemption)</li>
                  <li>Donation Amount and Frequency</li>
                  <li>Payment Information (processed securely via Razorpay)</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">How We Use Donor Data</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Processing Donations:</strong> To complete and record your donation transaction.</li>
                  <li><strong>Tax Compliance:</strong> To issue 80G certificates and comply with Indian tax regulations.</li>
                  <li><strong>Communication:</strong> To send donation receipts, project updates, and thank you messages.</li>
                  <li><strong>Internal Analysis:</strong> To understand donor patterns and improve our fundraising efforts.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Data Protection</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All payment data is encrypted and processed through Razorpay's secure payment gateway.</li>
                  <li>We do not store complete credit/debit card details on our servers.</li>
                  <li>Access to donor data is restricted to authorized personnel only.</li>
                  <li>We implement industry-standard security measures to protect your information.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Data Sharing</h2>
                <p className="mb-4">We do not sell, trade, or rent donor information to third parties. We may share data only:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>With payment processors to complete transactions</li>
                  <li>With auditors for compliance purposes</li>
                  <li>When required by law or government authorities</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Donor Rights</h2>
                <p className="mb-4">As a donor, you have the right to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Access your donation history and personal information</li>
                  <li>Request corrections to your personal data</li>
                  <li>Opt-out of promotional communications</li>
                  <li>Request deletion of your data (subject to legal retention requirements)</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Data Retention</h2>
                <p>We retain donor records for a minimum of 8 years as required by Indian tax laws. After this period, data may be securely deleted unless needed for ongoing charitable purposes.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Anonymous Donations</h2>
                <p>We respect donors who wish to remain anonymous. However, PAN details are mandatory for donations above ₹2,000 as per Indian tax regulations.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
                <p>For any questions about donor data or to exercise your rights:</p>
                <p className="mt-2">Email: support@dharma-astra.org<br />Phone: +91 8977116677</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default DonorDataPolicy;
